import appConstant from "../../../constants/app";
import * as storage from "../../utility/storage";
import * as utils from "../../utility/utils";

class ManageOverRideService {
  isPinValid = false;
  token = "";
  message = "";
  pin = "";
  expire = null;

  isManager = (isRemoteAuthEnabled = false) => {
    let userDetail = storage.getLocalStorage(appConstant.TOKEN);
    if (isRemoteAuthEnabled) {
      return (
        utils.customerAdminRoleFound(userDetail.profile) ||
        utils.checkSupervisorFound(userDetail.profile) ||
        (!utils.isNullOrWhiteSpace(this.token))
      );
    } else {
      this.reset();
      return (
        utils.customerAdminRoleFound(userDetail.profile) ||
        utils.checkSupervisorFound(userDetail.profile)
      );
    }
  };

  checkExpiry = () => {
    if (!utils.isNullOrWhiteSpace(this.expire)) {
      let d = this.pinExpire(this.expire);

      if (!d) {
        return false;
      }

      let ticks = d.valueOf() - new Date().valueOf();
      let mm = Math.round((ticks / (60 * 1000)) % 60);
      return mm <= 0;
    }
    return true;
  };

  pinExpire = (date) => {
    if (!date) {
      return null;
    }

    let dateUtc = new Date(date).getTime();
    let d = new Date(0); // The 0 here is the key, which sets the date to the epoch
    d.setUTCSeconds(dateUtc);

    return new Date(date);
  };

  reset = () => {
    this.isPinValid = false;
    this.token = "";
    this.message = "";
    this.pin = "";
    this.expire = null;
  };
  setAuthData = (data) => {
    this.isPinValid = true;
    this.token = data.token;
    this.message = "";
    this.pin = "";
    this.expire = data.expires;
  };
}

export default new ManageOverRideService();
